// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"zea-z","subtitle":"Aea-z","wrapper":"Bea-z","leftArrow":"Cea-z","rightArrow":"Dea-z"};